import { random, round2 } from "../helpers/helpers";

const daysInMonth = (year, month) =>
    new Date(year, month, 0).getDate();

export const generateVibrationChartMonthDemo = ({
                                                    meter_id,
                                                    year,
                                                    month,
                                                }) => {
    const today = new Date();
    const totalDays = daysInMonth(year, month);

    const isCurrentMonth =
        today.getFullYear() === Number(year) &&
        today.getMonth() + 1 === Number(month);

    const maxDay = isCurrentMonth ? today.getDate() : totalDays;

    const daily_energy_data = [];

    for (let day = 1; day <= maxDay; day++) {
        const baseAcc1 = random(0.02, 0.04);
        const baseAcc3 = random(0.95, 1.05);
        const baseTemp = random(29, 34);

        daily_energy_data.push({
            day,

            avg_acc_axis1: round2(baseAcc1),
            avg_acc_axis2: 0.0,
            avg_acc_axis3: round2(baseAcc3),

            avg_axis1: 0.0,
            avg_axis2: 0.0,
            avg_axis3: 0.0,

            min_acc_axis1: round2(baseAcc1 - 0.01),
            min_acc_axis2: "0.00",
            min_acc_axis3: round2(baseAcc3 - 0.02),

            max_acc_axis1: round2(baseAcc1 + 0.01),
            max_acc_axis2: "0.00",
            max_acc_axis3: round2(baseAcc3 + 0.06),

            min_axis1: "0.00",
            min_axis2: "0.00",
            min_axis3: "0.00",

            max_axis1: "0.00",
            max_axis2: "0.00",
            max_axis3: "0.00",

            avg_temp: round2(baseTemp),
            min_temp: round2(baseTemp - random(1, 2)),
            max_temp: round2(baseTemp + random(1, 2)),

            normal_limit: "4.50",
            marginal_limit: "11.20",
        });
    }

    return {
        meter_id: Number(meter_id),
        year: Number(year),
        month: Number(month),
        daily_energy_data,
    };
};
